var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-system-logo"},[_c('img',{staticClass:"ma-1",attrs:{"src":_vm.src,"alt":"systems.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }